import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {useLocation} from 'react-router';
import {useNavigate} from 'react-router-dom';
import {FileOutlined, FormOutlined, LeftOutlined, PlusOutlined, UploadOutlined} from '@ant-design/icons';
import {useMutation, useQuery} from '@apollo/client';
import {Button, Empty, message, Space, Upload} from 'antd';
import {RcFile} from 'antd/lib/upload';
import axios from 'axios';
import cn from 'classnames';
import dayjs from 'dayjs';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import labels from '../../config/labels.json';
import {ILabel} from '../../config/lebels-type';
import {VIEWER_FILE, VIEWER_TEXT, WRITE} from '../../config/routes';
import {Store} from '../../model/store/Store';
import {createStory, createStoryVariables} from '../../shared/graphql/__generated__/createStory';
import {stories, storiesVariables} from '../../shared/graphql/__generated__/stories';
import {MUTATION_CREATE_STORY, QUERY_STORIES} from '../../shared/graphql/story';
import {fullUrl} from '../../shared/helpers/fullUrl';

import cls from './Story.module.scss'

export const Story = observer(() => {

    const navigate = useNavigate()
    const {state} = useLocation();
    const {t} = useTranslation()
    const {auth} = useInstance(Store)

    const [loading, setLoading] = useState<boolean>(false);
    const [create] = useMutation<createStory, createStoryVariables>(MUTATION_CREATE_STORY)

    const history = useQuery<stories, storiesVariables>(QUERY_STORIES, {
        variables: {
            filters: {
                identifier: {eq: state.identifier},
            },
            sort: ['createdAt:DESC'],
            pagination: {
                limit: 10
            }
        },
    })

    const label = _.filter(labels, (label: ILabel) => label.identifier === state.identifier)[0]?.label;
    const welcome = _.filter(labels, (label: ILabel) => label.identifier === state.identifier)[0]?.welcome;

    const beforeUpload = (file: RcFile) => {
        const isViewer =
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'image/gif' ||
            file.type === 'application/pdf' ||
            file.type === 'text/csv' ||
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        if (!isViewer) {
            message.error('Файл должен быть в формате JPG, PNG, GIF, PDF, XLSX, DOCX');
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('Файл должен быть не больше 10Мб');
        }
        return isViewer && isLt10M;
    };

    return (
        <Layout header={<Header title={t(label)}
                                left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                              icon={<LeftOutlined/>}/>}/>}>
            <div className={cls.page}>
                <div className={cls.block}>
                    <h3><PlusOutlined/> {t('Add data')}</h3>
                    <div className={'caption'}>
                        {t('Upload a file with the results or write it yourself. The download history and descriptions will appear below.')}
                    </div>
                    <Space>

                        <Upload
                            // listType="picture-circle"
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            customRequest={async ({file}) => {
                                setLoading(true)
                                const url = fullUrl('/api/upload')
                                const formData = new FormData();
                                formData.append('files', file);
                                axios.post(url, formData, {
                                    headers: {
                                        Authorization: `Bearer ${auth.token}`,
                                        'Content-Type': 'multipart/form-data',
                                    }
                                }).then(async (res) => {
                                    const file = res.data[0]
                                    await create({
                                        variables: {
                                            data: {
                                                identifier: state.identifier,
                                                file: file.id,
                                            }
                                        },
                                        onCompleted: () => {
                                            history.refetch()
                                            setLoading(false)
                                            // navigate(INDEX)
                                        },
                                    })
                                })

                            }}
                        >
                            <Button loading={loading} type={'primary'} icon={<UploadOutlined/>}>{t('Upload')}</Button>
                        </Upload>

                        <Button onClick={() => navigate(WRITE, {state:{identifier: state.identifier}})}>{t('Write')}</Button>
                    </Space>
                </div>

                {welcome &&
                    <div className={cls.block}>
                        <h3>{t('Description')}</h3>
                        <div>{t(welcome)}</div>
                    </div>
                }

                <div className={cls.block}>
                    <h3>{t('History')}</h3>
                    {history.data?.stories.length === 0 && <Empty/>}
                    {history.data?.stories.length! > 0 && _.map(history.data?.stories, (story) => {

                        if (story?.file) {
                            const viewerState = {
                                identifier: state.identifier,
                                url: fullUrl(story?.file.url),
                                mime: story.file.mime
                            }
                            return (
                                <div key={story.documentId} className={cls.story} onClick={() => navigate(VIEWER_FILE, {state:viewerState})}>
                                    <FileOutlined/>
                                    <div className={cls.description}>{story.file.name}</div>
                                    <div className={cn(['caption', cls.date])}>{dayjs(story.createdAt).format('DD.MM.YYYY')}</div>
                                </div>
                            )
                        }

                        if (story?.description) {
                            const viewerState = {
                                identifier: state.identifier,
                                description: story.description,
                            }
                            return (
                                <div key={story.documentId} className={cls.story} onClick={() => navigate(VIEWER_TEXT, {state:viewerState})}>
                                    <FormOutlined/>
                                    <div className={cls.description}>{story.description}</div>
                                    <div className={cn(['caption', cls.date])}>{dayjs(story.createdAt).format('DD.MM.YYYY')}</div>
                                </div>
                            )
                        }


                        }
                    )}
                </div>
            </div>
        </Layout>

    )
})